export default "__VITE_ASSET__9cf99e48__"